var map = {
	"./btc.png": "99a6",
	"./deal_1.png": "60ea",
	"./deal_10.png": "fdea",
	"./deal_11.png": "ab48",
	"./deal_12.png": "0966",
	"./deal_13.png": "03d5",
	"./deal_14.png": "6090",
	"./deal_15.png": "e786",
	"./deal_16.png": "5294",
	"./deal_17.png": "034e",
	"./deal_18.png": "490d",
	"./deal_2.png": "9c93",
	"./deal_3.png": "fe3b",
	"./deal_4.png": "fa12",
	"./deal_5.png": "3a87",
	"./deal_6.png": "5e6a",
	"./deal_7.png": "25b0",
	"./deal_8.png": "6ccf",
	"./deal_9.png": "12fd",
	"./doge.png": "8285",
	"./eos.png": "5598",
	"./eth.png": "b82a",
	"./fil.png": "bb60",
	"./fire.png": "540c",
	"./sw_1.png": "2c23",
	"./sw_2.png": "a578",
	"./行情_操作.png": "f059"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "737b";